import { provideStoreDevtools } from '@ngrx/store-devtools';

export function provideReduxDevTools(isProduction: boolean) {
  const devProviders = !isProduction
    ? [provideStoreDevtools({ maxAge: 25 , connectInZone: true})]
    : [];

  return devProviders;
}
